$('.alsoslick').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '.prevb',
    nextArrow: '.nextb',
    draggable: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1441,
        settings:{
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1025,
        settings: {
          centerMode: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          draggable: true
          }
        },
        {
        breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
        breakpoint: 450,
          settings: {
          slidesToShow:1,
          slidesToScroll: 1
          }
        }
      ]
  });
  $('.alsoslick2').slick({
    infinite: true,
    draggable:true,
    prevArrow: '.prevw',
    nextArrow: '.nextw',
    autoplay: true,
    autoplaySpeed: 3000,
  });

  // Clientes
  $('.minslick').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows:false,
    prevArrow: '.prevw',
    nextArrow: '.nextw',
    asNavFor: '.bigslick',
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1441,
        settings:{
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
        }
      }

      ]
  });

  $('.minslick2').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows:false,
    asNavFor: '.bigslick',
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1441,
        settings:{
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3
        }
      },
      ]
  });

  $('.bigslick').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    fade: true,
    asNavFor: '.minslick, .minslick2',
    responsive: [
      {
        breakpoint: 451,
        settings:  {
          slidesToShow:1,
          draggable:true,
          fade:false
      }
    },
    ]
  });

$('#sliderHome').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  lazyLoad: 'ondemand',
  //arrows:false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 9000,
  speed: 1000,
  prevArrow: '.back3',
  nextArrow: '.next3',
});

$('#allies').slick({
  arrows: false,
  dots: true,
  autoplay: true,
  autoplaySpeed: 2000,
  mobileFirst: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 320,
      settings:{
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 750,
      settings:{
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 1020,
      settings:{
        slidesToShow: 5,
      }
    },
    {
      breakpoint: 1350,
      settings:{
        slidesToShow: 7,
      }
    },
    {
      breakpoint: 1900,
      settings:{
        slidesToShow: 8,
      }
    },
  ]
})

$('#sliderHigh').slick({
  arrows: false,
  dots: true,
  autoplay: true,
  autoplaySpeed: 3000,
  mobileFirst: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 320,
      settings:{
        slidesToShow: 1,
      }
    },
    {
      breakpoint: 750,
      settings:{
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 1020,
      settings:{
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 1270,
      settings:{
        slidesToShow: 3,
        dots: false,
        arrows: true,
        prevArrow: '.back4',
        nextArrow: '.next4',
      }
    },
    {
      breakpoint: 1350,
      settings:{
        slidesToShow: 3,
        dots: false,
        arrows: true,
        prevArrow: '.back4',
        nextArrow: '.next4',
      }
    },
  ]
})
